import { Button } from '@atlas/ui-primitives'

interface LibraryPagerProps {
	page: number
	hasNextPage: boolean
	hasPreviousPage: boolean
	/** True while a page is in flight — both steps go quiet rather than queueing a second jump. */
	isFetching?: boolean
	onPageChange: (page: number) => void
}

/**
 * Prev/Next stepper for the Library grid.
 *
 * Deliberately not `PaginationFooter`: that component requires `total` and
 * `totalPages`, and discovery reports neither — a fabricated count would be an
 * invented value, and threading one through a shared component would make it a
 * contract other callers could come to rely on. The current page number is shown
 * on its own, with no "of N".
 */
export function LibraryPager({ page, hasNextPage, hasPreviousPage, isFetching, onPageChange }: LibraryPagerProps) {
	if (!hasNextPage && !hasPreviousPage) return null

	return (
		<nav aria-label="Library pages" className="flex items-center justify-end gap-3">
			<Button
				variant="secondary"
				className="rounded-ds-full"
				isDisabled={!hasPreviousPage || isFetching}
				onPress={() => onPageChange(page - 1)}
			>
				Previous
			</Button>
			<span className="text-ds-sm text-ds-text-muted">Page {page}</span>
			<Button
				variant="secondary"
				className="rounded-ds-full"
				isDisabled={!hasNextPage || isFetching}
				onPress={() => onPageChange(page + 1)}
			>
				Next
			</Button>
		</nav>
	)
}
